import { render, staticRenderFns } from "./shipmentSite.vue?vue&type=template&id=404ecd86&scoped=true&"
import script from "./shipmentSite.vue?vue&type=script&lang=js&"
export * from "./shipmentSite.vue?vue&type=script&lang=js&"
import style0 from "./shipmentSite.vue?vue&type=style&index=0&id=404ecd86&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404ecd86",
  null
  
)

export default component.exports